import { Select } from "antd";
import { useMapboxContext } from "../mapbox/context/mapbox-context";

const SelectStyle = () => {
    const { setMapboxStyle } = useMapboxContext();

    const handleChange = (value: string) => {
        setMapboxStyle(value)
      };


    return (    <Select
        defaultValue={"mapbox://styles/lagarsoft/cljej4m1a00ag01p59ssebwcc"}
        style={{ width: '90%', marginBottom:"20px" }}
        onChange={handleChange}
        options={[
         
          { value: 'mapbox://styles/lagarsoft/cljd1czp6000g01qrhebl61d8', label: 'Streets Satellite' },
          { value: 'mapbox://styles/lagarsoft/cljdoy2ro005o01qkccmx81uu', label: 'Streets Satellite Empty' },
          { value: 'mapbox://styles/lagarsoft/cljd1fcsr000j01qkhezi4svu', label: 'Monochrome' },        
          { value: 'mapbox://styles/lagarsoft/cljej4m1a00ag01p59ssebwcc', label: 'Streets Satellite Lots' },        
        ]}
      />)
}

export default SelectStyle;